import { render, staticRenderFns } from "./set-dialog.vue?vue&type=template&id=1219a54c&"
import script from "./set-dialog.vue?vue&type=script&lang=js&"
export * from "./set-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports